/**
 * pages/Markets.tsx — Stage-II placeholder.
 *
 * Explicit contract from the user:
 *
 *   * Custody-only. Crypto in AsterCash will be held by a licensed
 *     custodian partner. Users never manage private keys, sign
 *     transactions, or run wallet software from their device.
 *   * The verbs are Buy and Sell.
 *   * A custody partner and written sponsor-bank permission must be
 *     in place before this ships. Neither exists today.
 *   * The page's job is only to prevent a 404 from the bottom-nav
 *     Markets tab.
 */

import { Card } from "../components";
import { AppShell } from "./AppShell";
import styles from "./Markets.module.css";

export function Markets() {
  return (
    <AppShell current="markets">
      <header className={styles.pageHeader}>
        <div>
          <p className={styles.eyebrow}>Markets</p>
          <h1 className={styles.pageTitle}>Coming soon</h1>
        </div>
      </header>

      <Card className={styles.hero} padding={0}>
        <div className={styles.heroInner}>
          <p className={styles.heroKicker}>Buy and sell — through a licensed partner</p>
          <p className={styles.heroCopy}>
            When AsterCash Markets opens you will be able to buy and sell
            supported assets from within your AsterCash balance. Your
            purchases will be held in custody by a licensed partner regulated
            for the asset type — not stored on your device.
          </p>
        </div>
      </Card>

      <div className={styles.notesGrid}>
        <Card className={styles.noteCard}>
          <p className={styles.noteTitle}>What Markets will do</p>
          <ul className={styles.noteList}>
            <li>Show prices for supported assets.</li>
            <li>Let you buy or sell from your AsterCash balance in one screen.</li>
            <li>Track your positions and cost basis for you.</li>
          </ul>
        </Card>

        <Card className={styles.noteCard}>
          <p className={styles.noteTitle}>What Markets will not do</p>
          <ul className={styles.noteList}>
            <li>Store private keys on this device or any device.</li>
            <li>Ask you to be responsible for asset storage.</li>
            <li>Support unregistered assets or unlicensed venues.</li>
          </ul>
        </Card>
      </div>

      <p className={styles.footNote}>
        Markets is a Stage II product. It ships only after custody and
        sponsor-bank approvals are on paper. Follow announcements at{" "}
        <span className={styles.footStrong}>astercash.com/updates</span>.
      </p>
    </AppShell>
  );
}
